<template>
  <!-- 第二步：申报项目基本信息 -->
  <div class="projectInfo">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="165px"
      class="form-wrap"
      :disabled="disabled"
    >
      <div class="form-title">基本信息</div>
      <el-form-item label="项目名称：" prop="projectName">
        <el-input v-model="form.projectName" placeholder="请输入" clearable />
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目负责人：" prop="projectManager">
            <el-input v-model="form.projectManager" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话：" prop="tel">
            <el-input v-model="form.tel" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="项目方向：" prop="projectDirection">
        <el-input v-model="form.projectDirection" placeholder="请输入" clearable />
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目建设起止年月：" prop="buildDate">
            <el-date-picker
              v-model="form.buildDate"
              type="daterange"
              range-separator="—"
              start-placeholder="开始日期"
              value-format="yyyy-MM-dd"
              end-placeholder="结束日期"
              style="width:100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目总投资金额：" prop="investment">
            <el-input v-model="form.investment" placeholder="请输入" clearable class="w350" />
            <span>万元</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目已投资金额：" prop="invested">
            <el-input v-model="form.invested" placeholder="请输入" clearable class="w350" />
            <span>万元</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="项目建设主要内容：" prop="content">
        <el-input
          v-model="form.content"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 6 }"
          placeholder="请输入"
          clearable
        />
      </el-form-item>
      <el-row class="f-r">
        <el-form-item label="附件：">
          <el-upload
            v-if="!disabled"
            action="/service-center/api/v1/upload/file"
            :on-success="handleAvatarSuccess"
            :on-remove="removeFile"
            class="iploadInput f-r a-c"
            :headers="headers"
            :before-upload="beforeAvatarUpload"
            :show-file-list="true"
            :limit="20"
          >
            <div style="color:#2d50a1;cursor:pointer">
              <i class="el-icon-upload2"></i>上传附件
            </div>
          </el-upload>
          <div
            v-if="showFile"
            class="downFile"
            @click="downloadFile(form.file, form.fileName)"
          >{{ form.fileName }}</div>
        </el-form-item>
      </el-row>
      <div class="form-title" style="margin-bottom:5px">项目指标</div>
      <p>说明：项目建成后，实现的降本提质增效等量化指标。（以下4项指标至少填写2项以上。此外，可根据项目情况新增其他量化指标）</p>
      <el-row>
        <el-col :span="12">
          <el-form-item label="降低企业成本：">
            <el-input v-model="indexForm.cost" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="降低不良品率：">
            <el-input v-model="indexForm.defective" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="提高生产运营效率：">
            <el-input v-model="indexForm.efficient" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="提高能源利用率：">
            <el-input v-model="indexForm.utilization" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="indexName" label="指标名称" align="center">
        <template slot-scope="scope">
          <el-input v-model="scope.row.indexName" placeholder="请输入" clearable :disabled="disabled" />
        </template>
      </el-table-column>
      <el-table-column prop="indexValue" label="指标值" align="center">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.indexValue"
            placeholder="请输入"
            clearable
            :disabled="disabled"
          />
        </template>
      </el-table-column>
      <el-table-column prop="indexCompany" label="单位" align="center">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.indexCompany"
            placeholder="请输入"
            clearable
            :disabled="disabled"
          />
        </template>
      </el-table-column>
      <el-table-column prop="indexCompany" label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button type="danger" @click="deleteIndex(scope)" :disabled="disabled">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center;margin-top: 20px;">
      <el-button type="primary" @click="addIndex" :disabled="disabled">新增指标</el-button>
      <!-- <el-button
        v-show="tableData.length > 1"
        type="danger"
        @click="deleteIndex"
        :disabled="disabled"
      >删除指标</el-button>-->
    </div>
  </div>
</template>

<script>
import { saveSecondInfo, getSecondInfo } from "../../utils/interface";
/* 是否是正数 */
const straight = (rule, value, callback) => {
  // console.log(rule, value);
  if (!value) {
    callback(new Error(rule.message));
  }
  let reg = /^\d+(?=\.{0,1}\d+$|$)/;
  if (!reg.test(value)) {
    callback(new Error());
  }
  callback();
};
const form = () => {
  return {
    projectName: "", // 项目名称
    projectManager: "", // 项目负责人
    tel: "", // 联系电话
    projectDirection: "", // 项目方向
    buildDate: "", // 项目建设起止年月
    startDate: "", // 项目建设开始时间
    endDate: "", // 项目建设结束时间
    investment: "", // 项目总投资金额
    invested: "", // 项目已投资金额
    content: "", // 项目建设主要内容
    file: "", //   附件地址
    fileName: "", // 附件名称
    cost: "", // 降低企业成本
    defective: "", // 降低不良品率
    efficient: "", // 提高生产运营效率
    utilization: "" // 提高能源利用率
  };
};
const rules = () => {
  return {
    projectName: [
      { required: true, message: "请输入项目名称", trigger: "blur" }
    ],
    projectManager: [
      { required: true, message: "请输入项目负责人", trigger: "blur" }
    ],
    tel: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
    projectDirection: [
      { required: true, message: "请输入项目方向", trigger: "blur" }
    ],
    buildDate: [
      { required: true, message: "请选择项目建设起止年月", trigger: "change" }
    ],
    investment: [
      {
        required: true,
        validator: straight,
        message: "请输入项目总投资金额(0或正数)",
        trigger: "blur"
      }
    ],
    invested: [
      {
        required: true,
        validator: straight,
        message: "请输入项目已投资金额(0或正数)",
        trigger: "blur"
      }
    ],
    content: [
      { required: true, message: "请输入项目建设主要内容", trigger: "blur" }
    ]
  };
};
export default {
  name: "",
  components: {},
  props: {
    projectId: String
  },
  data() {
    return {
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token") //	可以是授权凭证用的参数值
      },
      form: form(),
      rules: rules(),
      indexForm: {
        cost: "", // 降低企业成本
        defective: "", // 降低不良品率
        efficient: "", // 提高生产运营效率
        utilization: "" // 提高能源利用率
      }, // 4个指标，至少填2个
      tableData: [
        { indexName: "", indexValue: "", indexCompany: "" } // 默认至少有一条
      ],
      disabled: false,
      uuid: "", // 本步骤的uuid
      showFile: false
    };
  },
  watch: {
    "form.buildDate"(val) {
      if (val) {
        this.form.startDate = val[0];
        this.form.endDate = val[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      // console.log(val, this.form)
    }
  },
  computed: {},
  created() {},
  mounted() {
    if (this.$route.query.projectId) {
      // console.log('第两步')
      this.getSecondInfo(this.$route.query.projectId);
    }
  },
  methods: {
    /* 新增指标 */
    addIndex() {
      this.tableData.push({
        indexName: "",
        indexValue: "",
        indexCompany: ""
      });
    },
    /* 删除指标 */
    deleteIndex(row) {
      if (this.tableData.length == 1) {
        this.$message.warning("请至少保留一条指标！");
        return;
      }
      this.$confirm("确认删除该条么！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.tableData.splice(row.$index, 1);
      });
    },
    /* 获取第二步详情 */
    getSecondInfo(projectId) {
      getSecondInfo(projectId).then(res => {
        if (res.success && Object.keys(res.data).length > 0) {
          this.form = res.data;
          this.form.buildDate = [this.form.startDate, this.form.endDate];
          this.disabled =
            this.$route.query.status == "INIT" ||
            this.$route.query.status == "REJECT"
              ? false
              : true;
          this.indexForm = {
            cost: res.data.cost,
            defective: res.data.defective,
            efficient: res.data.efficient,
            utilization: res.data.utilization
          };
          this.tableData = res.data.index;
          this.uuid = res.data.uuid;
          this.showFile = true;
        } else {
          this.form = form();
          this.indexForm = {
            cost: "",
            defective: "",
            efficient: "",
            utilization: ""
          };
          this.tableData = [
            { indexName: "", indexValue: "", indexCompany: "" }
          ];
        }
      });
    },
    /* 第二步保存 */
    save() {
      // console.log('第二步保存')
      this.$refs.form.validate(valid => {
        if (valid) {
          let sum = 0;
          for (let key in this.indexForm) {
            if (this.indexForm[key]) {
              sum++;
            }
          }
          if (sum < 2) {
            this.$message({
              message: "项目指标至少填写两项！",
              type: "warning"
            });
            return;
          }
          saveSecondInfo({
            policyUuid: this.$route.query.policyUuid,
            userUuid: this.$store.state.isUsermessage.uuid,
            projectId: this.projectId,
            ...this.form,
            ...this.indexForm,
            index: this.tableData,
            uuid: this.uuid
          }).then(res => {
            if (res.success) {
              this.$message({
                message: res.message,
                type: "success"
              });
              this.uuid = res.data.uuid;
              this.$parent.activeStep++;
            } else {
              this.$message({
                message: res.message,
                type: "error"
              });
            }
          });
        }
      });
    },
    beforeAvatarUpload(file) {
      let isLt10M = file.size / 1024 / 1024 < 10;
      let fileNameLength = file.name.length <= 100;
      // this.fileName = file.name
      let fileName = file.name.lastIndexOf(".");
      const fileNameLen = file.name.length;
      const fileTypeName = file.name.substring(fileName, fileNameLen);
      if (!isLt10M) {
        this.$alert("文件大小不能超过10M", "提示", {
          confirmButtonText: "确定"
        });
      } else if (!fileNameLength) {
        this.$alert("文件名（包含后缀名）的最大长度不能超过100个字符", "提示", {
          confirmButtonText: "确定"
        });
      }
      return isLt10M && fileNameLength;
    },
    handleAvatarSuccess(res) {
      if (res) {
        this.form.file = res.url;
        this.form.fileName = res.fileName;
        this.showFile = false;
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success"
        });
        // console.log(this.form)
      }
    },
    removeFile() {
      this.form.file = "";
      this.form.fileName = "";
      console.log(this.form);
    },
    /* 下载文件 */
    downloadFile(url, name) {
      fetch(url).then(res => {
        res.blob().then(blob => {
          const blobUrl = window.URL.createObjectURL(blob);
          // 这里的文件名根据实际情况从响应头或者url里获取
          const filename = name;
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        });
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";

.projectInfo {
  min-height: 300px;
  margin-bottom: 35px;
  border-radius: 12px;

  .w350 {
    width: 350px;
  }

  .downFile {
    display: inline-flex;
    height: 40px;
    align-items: center;
    box-sizing: border-box;
    font-size: 14px;
    color: @basic-colors;
    cursor: pointer;
    text-decoration: underline;
  }

  .form-wrap {
    padding: 10px 20px;
    .bs();

    p {
      font-size: 14px;
      color: #888888;
      line-height: 1.7;
      margin-bottom: 40px;
    }

    .iploadInput {
      display: inline-flex;
      /deep/ .el-upload {
        align-self: start;
      }
    }

    .form-title {
      font-size: 14px;
      font-weight: bold;
      margin: 0 0 30px 0px;
      position: relative;
      color: #535353;

      &::before {
        position: absolute;
        content: "";
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #000;
        top: 50%;
        left: -8px;
        transform: translateY(-50%);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/projectApply/projectInfo.vue